import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';

export interface ISubFliFormDialogResult {
    isOfThatItem?: boolean;
    caption: IDynamicKeyValue;
    name: string;
}
